import { getObjectById } from '@eventr/common'
import { Gutters, MainButton, Typography } from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../i18n/i18next'
import { useBoundStore } from '../../state/bound.store'
import { openBrowser } from '../../utils'
import { reactAppStage } from '../../utils/reactAppStage'
import { NavigationView } from '../layout/NavigationView'
export const ProviderManagePage = () => {
    const { idItem } = useParams<{
        idItem: string
    }>()
    const { selectedItinerary } = useBoundStore(
        useShallow((s) => {
            return { selectedItinerary: s.selectedItinerary }
        })
    )
    const providerData = useMemo(() => {
        const hotel = getObjectById(idItem, selectedItinerary)
        return hotel?.hotelProvider ?? []
    }, [selectedItinerary, idItem])

    const getHotelPlannerUrl = () => {
        const stage = reactAppStage()
        switch (stage) {
            case 'dev':
            case 'test':
            case 'local':
                return 'https://eventr-test-mobile.hotelplanner.com'
            default:
                return 'https://eventr-mobile.hotelplanner.com'
        }
    }
    const onPdfClick = (link: string) => {
        /// need to change urls start to match mobile one. it turns out it does not matter what site we use for this
        const second = link.split('hotelplanner.com')[1]
        const newLink = getHotelPlannerUrl() + second
        openBrowser(newLink)
    }
    const onMakeChangesClick = (link: string) => {
        const second = link.split('hotelplanner.com')[1]
        const newLink = getHotelPlannerUrl() + second
        openBrowser(newLink)
    }
    return (
        <NavigationView
            navigationBarTitle={i18n.t('booking.manageYourBookings')}
            usePageTransition
            backButtonAction={() => {
                window.goBack()
            }}
        >
            <Box display={'grid'}>
                <Gutters>
                    {providerData.map((provider, i) => (
                        <Stack
                            justifyContent={'space-between'}
                            key={i}
                            direction={'row'}
                        >
                            <Stack>
                                <Typography variant="bodyBold">
                                    {i18n.t('booking.provider')}
                                </Typography>
                                <Typography>{provider.provider}</Typography>
                                <Typography variant="bodyBold">
                                    {i18n.t('booking.confirmationNumber')}
                                </Typography>
                                <Typography>
                                    {provider.confirmationNumber}
                                </Typography>
                                <Typography variant="bodyBold">
                                    {i18n.t('booking.status')}
                                </Typography>
                                <Typography>{provider.status}</Typography>
                            </Stack>
                            <Stack spacing={'16px'}>
                                <MainButton
                                    onClick={() => {
                                        onPdfClick(provider.pdfLink)
                                    }}
                                >
                                    {i18n.t('booking.pdf')}
                                </MainButton>
                                <MainButton
                                    onClick={() => {
                                        onMakeChangesClick(provider.manageLink)
                                    }}
                                >
                                    {i18n.t('booking.makeChanges')}
                                </MainButton>
                            </Stack>
                        </Stack>
                    ))}
                </Gutters>
            </Box>
        </NavigationView>
    )
}
